import { computed, getCurrentInstance } from 'vue';
import { types } from '../../store/types/types';

export const useSearchAlert = () => {
  const { proxy } = getCurrentInstance();

  const isSteppedUp = computed<boolean>(() => proxy.$store.getters[types.GET_GLOBAL_STEPPED_UP]);

  const isVisible = computed<boolean>(() => isSteppedUp.value === false);

  const handleAlertClick = () => {
    localStorage.setItem('redirectedurlafterstepup', window.location.href);
    localStorage.setItem('redirectedurlbeforestepup', window.location.href);
    window.location.href = '/auth/stepup.php';
  };

  return {
    isVisible,
    handleAlertClick,
  };
};
